export default "__VITE_ASSET__Bj_a0TBN__"